export const DOCUMENT_URLS = {
    'AMTRUST_GDPR': '/document/eureko-privolitvena-izjava-2023-01.pdf',
    'IPID_SCA': '/document/IPID-SCA-SI-10-11-2022.pdf',
    'IPID_PCA': '/document/IPID-PCA-SI-10-11-2022.pdf',
    'IPID_BASIC': '/document/IPID-BASIC-SI-10-11-2022.pdf',
    'SPLOSNI_POGOJI_SCA_PCA': '/document/splosni-pogoji-ax-sca-pca-si-01-2023.pdf',
    'SPLOSNI_POGOJI_BASIC': '/document/splosni-pogoji-ax-ba-si-01-2023.pdf'
};